import styled, { css } from 'styled-components';

const UploadImageButtonWrapper = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-lg);
  cursor: pointer;
  height: 100%;
  opacity: 0.4;
  padding: 6px;
  width: 100%;

  :hover {
    border-color: var(--color-border-strong);
  }

  ${({ error }) =>
    error &&
    css`
      border: 2px solid var(--color-error-default);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      &,
      ${UploadButton} {
        opacity: 0.4;
      }

      :hover {
        border-color: var(--color-border-default);
      }
    `}
`;

const UploadButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: 2px dashed var(--color-border-strong);
  border-radius: var(--size-border-radius-md);
  color: var(--color-accent-secondary-default);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  text-decoration: none;
  width: 100%;

  :hover {
    background-color: transparent;
    color: var(--color-accent-secondary-default);
  }
`;

export { UploadButton, UploadImageButtonWrapper };
